// removed by extract-text-webpack-plugin
module.exports = {"black":"#000000","white":"#ffffff","wrapper":"_2eJ8TuJWvXppkea9xKE8qx"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Map/MapLegend/MapLegend.css
// module id = 1282
// module chunks = 0